// src/components/button/BtnAddAllSensors.tsx

import { AddTwoTone } from '@mui/icons-material'
import {
  IconButton,
  IconButtonProps,
  SxProps,
  Theme,
  Tooltip,
} from '@mui/material'

type Props = {
  onClick: () => void
  sx: SxProps<Theme>
} & IconButtonProps

export const BtnAddAllSensors = ({ onClick, sx }: Props) => (
  <Tooltip title={'Dem Sensor alle Benutzer zuweisen'}>
    <IconButton onClick={onClick} sx={sx}>
      <AddTwoTone />
    </IconButton>
  </Tooltip>
)
